// eslint-disable-next-line no-restricted-imports
import {
  LegalClientBranchForLegalClientFragment,
  Query_LegalClientController_GetList_AllOf_1_List_Items_Branches_Items_Status,
} from 'api/generated/graphql';
import { parseCountryEntity } from 'api/helpers/parseCountryEntity';
import { LegalClientInnerItemEntity } from 'api/types/entity/legal/legalClientInnerItemEntity';

export const parseLegalClientBranchItemEntity = (
  data: LegalClientBranchForLegalClientFragment
): LegalClientInnerItemEntity => ({
  id: data.id,
  name: data.fullName ?? '',
  registrationCountry: data.legalAddress
    ? parseCountryEntity(data.legalAddress.country)
    : undefined,
  residentialCountry: data.actualAddress
    ? parseCountryEntity(data.actualAddress.country)
    : undefined,
  createdAt: new Date(data.createdAt),
  archived:
    data.status ===
    Query_LegalClientController_GetList_AllOf_1_List_Items_Branches_Items_Status.Archived,
});
